import { DateTime } from "luxon";

export default function getRelativeDate(date) {
  const relative = DateTime.fromJSDate(date).toRelative();
  return relative;
}
